import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import SidebarContainer from '../../components/@container/sidebar-container';
import WholesalePartsHubSidebar from '../../components/@wholesale-parts-hub/wholesale-parts-hub-sidebar';
import WholesalePartsHubPartsOverview from '../../components/@wholesale-parts-hub/wholesale-parts-hub-parts-overview';
import BackToTop from '../../components/back-to-top';

const WholesalePartsCenterPartsOverview: NextPage = () => (
  <Layout title="Wholesale Parts Hub Overview" omit={true}>
    <SidebarContainer
      sidebar={<WholesalePartsHubSidebar />}
      content={<WholesalePartsHubPartsOverview />}
    />
    <BackToTop />
  </Layout>
);

export default WholesalePartsCenterPartsOverview;
